// extracted by mini-css-extract-plugin
module.exports = {"icommColor":"privacy-policy-module--icomm-color--3XDdW","blackColor":"privacy-policy-module--black-color--H12fo","textCenter":"privacy-policy-module--text-center--3ikNz"};